var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section__lk-content-item-right section__lk-content-item-data border-0 align-items-start justify-content-between"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }